export default __webpack_public_path__ + "assets/star-filled-component.a81bd0c2.svg";